import {
  GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
  GET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  GET_QUALITY_BANNER_STATS,
  GET_QUALITY_CAMP_STATS,
  SET_QUALITY_CAMP_STAT_LOADER,
  GET_QUALITY_FILTERS,
  GET_QUALITY_MEDIA_SOURCE,
  GET_QUALITY_WIDGETS,
  GET_REPORT_CAMPAIGNS_COUNT_BY,
  GET_TOP_MANAGEMENT_APP_PROFIT,
  GET_TOP_MANAGEMENT_CLIENT_SPEND,
  GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  GET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  GET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  GET_TOP_MANAGEMENT_OFFER_PROFIT,
  GET_TOP_MANAGEMENT_PROFIT,
  HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
  HIDE_REPORT_LOADER,
  SET_COUNT_BY_APP,
  SET_COUNT_BY_CLIENT,
  SET_COUNT_BY_MEDIABUYER,
  SET_COUNT_BY_OFFER,
  SET_MANAGERS_REPORT_DATE,
  SET_NON_CAHORT_REPORT_DATE,
  SET_PAYMENT_COST_INSPECTION_DATE,
  SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
  SET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  SET_QUALITY_BANNER_STATS,
  SET_QUALITY_CAMP_STATS,
  SET_QUALITY_EVENTS,
  SET_QUALITY_FILTERS,
  SET_QUALITY_MEDIA_SOURCE,
  SET_QUALITY_TABLE,
  SET_QUALITY_WIDGETS,
  SET_TOP_MANAGEMENT_APP_PROFIT,
  SET_TOP_MANAGEMENT_CLIENT_SPEND,
  SET_TOP_MANAGEMENT_DATE,
  SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  SET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  SET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  SET_TOP_MANAGEMENT_OFFER_PROFIT,
  SET_TOP_MANAGEMENT_PROFIT,
  SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
  SHOW_REPORT_LOADER,
  WIDGET_LOADER,
  SET_MEDIA_SOURCE_LOADER,
  REQUEST_DATA_UPDATE,
  GET_REPORT_QUALITY_EVENTS_STATS,
  SET_QUALITY_ADGROUPS_STAT_LOADER,
  SET_QUALITY_ADGROUPS_STATS,
  GET_QUALITY_ADGROUPS_STATS,
  GET_REPORT_RENT_STATS,
  SET_REPORT_RENT_STATS,
  GET_REPORT_RENT_WIDGETS,
  SET_REPORT_RENT_WIDGETS,
  SET_REPORT_RENT_STATS_LOADER,
  SET_REPORT_RENT_WIDGETS_LOADER,
} from "./actionTypes";

export const setQualityTable = data => ({
  type: SET_QUALITY_TABLE,
  payload: data,
});

export const setManagersReportDate = data => ({
  type: SET_MANAGERS_REPORT_DATE,
  payload: data,
});

export const setNonCahortReportDate = data => ({
  type: SET_NON_CAHORT_REPORT_DATE,
  payload: data,
});

export const setTopManagementDate = data => ({
  type: SET_TOP_MANAGEMENT_DATE,
  payload: data,
});

export const getQualityMediaSource = (data, events_params) => ({
  type: GET_QUALITY_MEDIA_SOURCE,
  payload: { data, events_params },
});

export const mediaSourceLoader = () => ({
  type: SET_MEDIA_SOURCE_LOADER,
});

export const setQualityMediaSource = data => ({
  type: SET_QUALITY_MEDIA_SOURCE,
  payload: data,
});

export const getTopManagementClientSpend = data => ({
  type: GET_TOP_MANAGEMENT_CLIENT_SPEND,
  payload: data,
});

export const setTopManagementClientSpend = data => ({
  type: SET_TOP_MANAGEMENT_CLIENT_SPEND,
  payload: data,
});

export const getReportCampaignCountBy = (data, by) => ({
  type: GET_REPORT_CAMPAIGNS_COUNT_BY,
  payload: data,
  by,
});

export const setReportCampaignCountByApp = data => ({
  type: SET_COUNT_BY_APP,
  payload: data,
});

export const setReportCampaignCountByOffer = data => ({
  type: SET_COUNT_BY_OFFER,
  payload: data,
});

export const setReportCampaignCountByClient = data => ({
  type: SET_COUNT_BY_CLIENT,
  payload: data,
});

export const setReportCampaignCountByMediaBuyer = data => ({
  type: SET_COUNT_BY_MEDIABUYER,
  payload: data,
});

export const getQualityTopManagementMediaBuyerSpend = data => ({
  type: GET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  payload: data,
});

export const setQualityTopManagementMediaBuyerSpend = data => ({
  type: SET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  payload: data,
});

export const getTopManagementAppProfit = data => ({
  type: GET_TOP_MANAGEMENT_APP_PROFIT,
  payload: data,
});

export const setTopManagementAppProfit = data => ({
  type: SET_TOP_MANAGEMENT_APP_PROFIT,
  payload: data,
});

export const getQualityTopManagementMediaBuyerStats = data => ({
  type: GET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  payload: data,
});

export const setQualityTopManagementMediaBuyerStats = data => ({
  type: SET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  payload: data,
});

export const setQualityEvents = data => ({
  type: SET_QUALITY_EVENTS,
  payload: data,
});

export const getQualityCampStats = (data, events_data) => ({
  type: GET_QUALITY_CAMP_STATS,
  payload: { data, events_data }
});

export const QualityCampStatsLoader = () => ({
  type: SET_QUALITY_CAMP_STAT_LOADER,
});

export const setQualityCampStats = data => ({
  type: SET_QUALITY_CAMP_STATS,
  payload: data,
});

export const getQualityAdgroupsStats = data => ({
  type: GET_QUALITY_ADGROUPS_STATS,
  payload: data,
});

export const QualityAdgroupsLoader = () => ({
  type: SET_QUALITY_ADGROUPS_STAT_LOADER,
});

export const setQualityAdgroupsStats = data => ({
  type: SET_QUALITY_ADGROUPS_STATS,
  payload: data,
});

export const getQualityBannerStats = (data, events_params) => ({
  type: GET_QUALITY_BANNER_STATS,
  payload: { data, events_params},
});

export const setQualityBannerStats = data => ({
  type: SET_QUALITY_BANNER_STATS,
  payload: data,
});

export const getQualityFilters = data => ({
  type: GET_QUALITY_FILTERS,
  payload: data,
});

export const setQualityFilters = data => ({
  type: SET_QUALITY_FILTERS,
  payload: data,
});

export const getQualityWidgets = data => ({
  type: GET_QUALITY_WIDGETS,
  payload: data,
});

export const setQualityWidgets = data => ({
  type: SET_QUALITY_WIDGETS,
  payload: data,
});

export const getTopManagementMediaBuyerProfit = data => ({
  type: GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  payload: data,
});

export const setTopManagementMediaBuyerProfit = data => ({
  type: SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  payload: data,
});

export const getTopManagementOfferProfit = data => ({
  type: GET_TOP_MANAGEMENT_OFFER_PROFIT,
  payload: data,
});

export const setTopManagementOfferProfit = data => ({
  type: SET_TOP_MANAGEMENT_OFFER_PROFIT,
  payload: data,
});

export const getTopManagementProfit = data => ({
  type: GET_TOP_MANAGEMENT_PROFIT,
  payload: data,
});

export const setTopManagementProfit = data => ({
  type: SET_TOP_MANAGEMENT_PROFIT,
  payload: data,
});

export const getPaymentCostInspectionReportList = data => ({
  type: GET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  payload: data,
});

export const setPaymentCostInspectionReportList = data => ({
  type: SET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  payload: data,
});

export const setPaymentCostInspectionDate = data => ({
  type: SET_PAYMENT_COST_INSPECTION_DATE,
  payload: data,
});

export const getPaymentCostInspectionReportFilters = () => ({
  type: GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
});

export const setPaymentCostInspectionReportFilters = data => ({
  type: SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
  payload: data,
});

export const showReportLoader = () => ({
  type: SHOW_REPORT_LOADER,
});

export const hideReportLoader = () => ({
  type: HIDE_REPORT_LOADER,
});

export const showPaymentCostInspectionReportLoader = () => ({
  type: SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
});

export const hidePaymentCostInspectionReportLoader = () => ({
  type: HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
});

export const widgetLoader = () => ({
  type: WIDGET_LOADER,
});

export const RequestDataUpdate = data => ({
  type: REQUEST_DATA_UPDATE,
  payload: data,
});

export const getReportEventsStats = data => ({
  type: GET_REPORT_QUALITY_EVENTS_STATS,
  payload: data,
});

export const setReportEventsStats = data => ({
  type: GET_REPORT_QUALITY_EVENTS_STATS,
  payload: data,
});

export const getReportRentStats = data => ({
  type: GET_REPORT_RENT_STATS,
  payload: data,
});

export const setReportRentStats = data => ({
  type: SET_REPORT_RENT_STATS,
  payload: data,
});

export const getReportRentWidgets = data => ({
  type: GET_REPORT_RENT_WIDGETS,
  payload: data,
});

export const setReportRentWidgets = data => ({
  type: SET_REPORT_RENT_WIDGETS,
  payload: data,
});

export const setReportRentStatsLoader = () => ({
  type: SET_REPORT_RENT_STATS_LOADER,
});

export const setReportRentWidgetsLoader = () => ({
  type: SET_REPORT_RENT_WIDGETS_LOADER,
});
